export interface SessionCodeResponse {
  sessionReference: string | null;
}
export enum ColourStyleEnum {
  Unknown = 0,
  Purple = 1,
  Blue = 2,
  Green = 3
}
export enum FontStyleEnum {
  Unknown = 0,
  Modern = 1,
  Classic = 2
}
